import { render, staticRenderFns } from "./TableTypesTab.vue?vue&type=template&id=59a03950&scoped=true&"
import script from "./TableTypesTab.vue?vue&type=script&lang=js&"
export * from "./TableTypesTab.vue?vue&type=script&lang=js&"
import style0 from "./TableTypesTab.vue?vue&type=style&index=0&id=59a03950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a03950",
  null
  
)

component.options.__file = "TableTypesTab.vue"
export default component.exports